<template>
  <!-- 파워 이펙트 프리셋 미리보기 — PowerMode를 주기적으로 자동 발동해 어떤 효과인지 보여준다. -->
  <power-mode
    ref="pm"
    class="effect-preview"
    :preset="preset"
    :show-combo="false"
    :shake="false"
    :particle-count="8"
  ></power-mode>
</template>

<script>
export default {
  name: "EffectPreview",
  props: {
    preset: { type: String, default: "particles" },
    // 자동 발동 간격(ms)
    interval: { type: Number, default: 300 },
  },
  mounted() {
    this._fire();
  },
  beforeDestroy() {
    if (this._t) clearTimeout(this._t);
  },
  methods: {
    _fire() {
      const pm = this.$refs.pm;
      const el = pm && pm.$refs.root;
      if (el) {
        const x = el.clientWidth / 2 + (Math.random() * 2 - 1) * 18;
        const y = el.clientHeight * 0.62;
        pm.trigger(x, y);
      }
      this._t = setTimeout(this._fire, this.interval);
    },
  },
};
</script>

<style scoped>
.effect-preview {
  display: block;
  width: 100%;
  height: 100%;
}
/* PowerMode 루트가 프리뷰 카드 전체를 채우도록(빈 슬롯이라 높이가 0이 되는 것 방지) */
.effect-preview >>> .power-mode,
.effect-preview >>> .power-mode__content {
  width: 100%;
  height: 100%;
}
</style>
